<div class="container-fluid" *ngIf="checkDataExists">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_MATERIAL_TAB.TITLE' | translate}}</legend>
        <div class="col-md-6">
            <div class="table-container mat-elevation-z8 ">
                <table mat-table [dataSource]="dataSourceMaterialWise" class="mat-table custom-table table-bordered">
                    <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                        <th mat-header-cell *matHeaderCellDef class="custom-header" [class.wide-column]="column.field === 'description'"> {{ column.header | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="custom-cell" [class.right-align]="column.isRightAlign" 
                        [class.description-cell]="column.field === 'description'" [title]="column.field === 'description' ? element[column.field] : ''"> 
                        {{ element[column.field] }} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterialWise"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterialWise;"></tr>
                </table>
            </div>
        </div>
        <div class="col-md-8 mb-2 levelwise-paginator-container addPaginatorStyle">
            <label for="materialWisePageSize" class="me-2 addMargin">{{'COMMON_LABELS.ITEMS_PER_PAGE' | translate}}</label>
            <input id="materialWisePageSize" type="number" min="1" [value]="pageSizeLevelWise" #materialPageSizeInput
                class="no-spinner custom-page-size-input"
                (change)="pageChangeTrigger(materialPageSizeInput, $event)">
            <mat-paginator #Levelpaginator class="small-font-paginator" [pageSize]="pageSizeLevelWise"
                showFirstLastButtons></mat-paginator>
        </div>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!checkDataExists">
    {{'REVIEW_SOL_MATERIAL_TAB.MATERIAL_DATA_NOT_FOUND' | translate}}
</div>